// src/sweedConfig.js
//
// TEST HARNESS toggle. When SWEED_TEST_MODE is true, the Apollo client intercepts
// the Dutchie GraphQL operations (MenuQuery, RetailerQuery, ProductQuery,
// GetSpecialsList) and resolves them from the Sweed REST proxy instead — so every
// retailer-based hook/component renders real Sweed sandbox data without changing
// the consumers. Flip to false to restore the normal Dutchie data path.
//
// This is a transitional test scaffold, not the final architecture (the real build
// refactors components to native Sweed shapes per the migration plan).

export const SWEED_TEST_MODE = false;

// Sweed sandbox store all retailerIds are routed to during the test.
export const SWEED_TEST_STORE_ID = 'jiptukcuy0v1ayfh';

// HARD-DISABLED for production. Sweed is in early development and must never run on
// live sites. This returns false unconditionally so that NOTHING can reactivate the
// Sweed test harness at runtime — not the SWEED_TEST_MODE constant, and not the
// ?sweedtest=1 URL override (both are intentionally bypassed). Every harness consumer
// (apolloClient sweedLink, CartContext, useAppStateGates, useFetchRest,
// useRetailerInitialization) gates on this function, so returning false restores the
// normal Dutchie data path everywhere.
//
// To resume Sweed development, restore the original body below:
//   try {
//       const v = new URLSearchParams(window.location.search).get('sweedtest');
//       if (v === '0') return false;
//       if (v === '1') return true;
//   } catch (e) { /* noop */ }
//   return SWEED_TEST_MODE;
export function isSweedTestMode() {
    return false;
}
